
const useStyles = () => {
    return {
        container:'w-full h-screen  flex justify-center items-center p-8 md:p-4  ',
        subContainer:" p-3 text-lg max-w-[600px] w-full ",
        btn:'text-white  border-2 px-6 py-3 my-2 flex justify-center hover:bg-rose-500 hover:scale-105 rounded-full ',
        title: "text-4xl font-bold inline border-b-4 border-white leading-tight text-white flex justify-center",}
  }
  
  export default useStyles